module.exports = __webpack_public_path__ + "img/court.e894207b.png";